<template>
  <div class="container">
    <div class="head">
      <img src="@/assets/back.png"
           style="margin: 10px"
           alt="返回"
           width="21"
           height="21"
           @click="go">
      <div>登录</div>
      <div style="margin-right: 10px;color: #FE003B"
           @click="register">注册</div>
    </div>
    <van-form>

      <van-field style="margin-top: 50px"
                 name="手机号码"
                 label="+86"
                 placeholder="请获取手机号码"
                 :rules="[{ required: true, message: '请获取手机号码' }]">
      </van-field>

      <van-field style="margin-top: 26px"
                 name="验证码"
                 placeholder="请输入验证码"
                 :rules="[{ required: true, message: '请输入验证码' }]">
        <template #button>
          <van-button class="panel"
                      size="small"
                      type="default">获取验证码</van-button>
        </template>
      </van-field>

      <van-radio-group v-model="radio"
                       style="margin-left: 12px;margin-top: 18px">
        <van-radio name="1"
                   shape="square"><span style="color: #0D75CF">我已阅读《用户注册条款协议》</span></van-radio>
      </van-radio-group>

    </van-form>

    <div class="weChatimg">
      <img src="@/assets/pay05.png"
           height="42"
           width="42" />
    </div>
    <div class="weChatl">微信授权登录</div>

    <div class="login">登录</div>
  </div>
</template>

<script>
export default {
  name: "index",
  data () {
    return {

      show: false,
      radio: 0,
    }
  },
  methods: {
    register () {
      this.$router.push({
        path: '/business/login/register'
      })
    },
    go () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  .head {
    background-color: #f3f3f3;
    height: 44px;
    line-height: 44px;
    opacity: 1;
    display: flex;
    justify-content: space-between;
  }
  .panel {
    width: 88px;
    height: 30px;
    background: rgba(7, 193, 96, 1);
    border: 1px solid rgba(7, 193, 96, 1);
    opacity: 1;
    border-radius: 2px;
    color: #ffffff;
  }
  .weChatimg {
    width: 100%;
    text-align: center;
    margin-top: 38px;
  }
  .weChatl {
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
  }
  .login {
    width: 95%;
    margin-left: 2%;
    height: 40px;
    background: linear-gradient(
      0deg,
      rgba(244, 4, 66, 1) 0%,
      rgba(226, 23, 75, 0.73) 100%
    );
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 40px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    opacity: 1;
    margin-top: 61px;
    margin-bottom: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/business/login/index.vue